import { render, staticRenderFns } from "./CustomerCategoryArticle.vue?vue&type=template&id=7fedae32&scoped=true&"
import script from "./CustomerCategoryArticle.vue?vue&type=script&lang=js&"
export * from "./CustomerCategoryArticle.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCategoryArticle.vue?vue&type=style&index=0&id=7fedae32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fedae32",
  null
  
)

export default component.exports